import { FC } from 'react'
import { TrueFalseCellProps } from './DataTables.d'
import { Tooltip } from 'primereact/tooltip'

const TrueFalseCell: FC<TrueFalseCellProps> = ({
    value,
    trueLabel,
    falseLabel,
}) => {
    return (
        <>
            <Tooltip
                target=".custom-target-icon"
                mouseTrack
                mouseTrackLeft={10}
            />
            <div className="text-center">
                {value ? (
                    <i
                        className="fa-solid fa-check-circle text-success custom-target-icon"
                        data-pr-tooltip={trueLabel}
                        data-pr-position="right"
                        data-pr-at="right+5 top"
                        data-pr-my="left center-2"
                    />
                ) : (
                    <i
                        className="fa-solid fa-times-circle text-danger custom-target-icon"
                        data-pr-tooltip={falseLabel}
                        data-pr-position="right"
                        data-pr-at="right+5 top"
                        data-pr-my="left center-2"
                    />
                )}
            </div>
        </>
    )
}

export default TrueFalseCell
